export default {
  text: 'Ganha <highlight>{{value}} pontos</highlight> com esta encomenda',
};
